// export const CerealsCropName=[
//     {value: "PADDY HYBRID", text: "PADDY HYBRID"},
//     {value: "PADDY BASMATI", text: "PADDY BASMATI"},
//     {value: "WHEAT", text: "WHEAT"},
// ]

export const CerealsCropName=['Paddy Hybrid', 'Paddy Basmati', 'Wheat']

export const oliSeedsCropName=['Groundnut', 'Soybean', 'Castor', 'Mustard', 'Rapeseed']

export const fiberOilSeedsCropName=['Cotton']

export const tuberCropName=['Turmeric', 'Onion', 'Potato', 'Sweet Potato', 'Garlic']

export const spiceCropName=['Cumin', 'Fennel', 'Isabgul']

export const vegetablesCropName=['Cucerbits', 'Brinjal', 'Tomato', 'Chillies', 'Cauliflower']

export const floriCultureCropName=['Roses', 'Jasmine', 'Marigold']

export const hortiCultureCropName=['Pome', 'Grapes', 'Mango', 'Banana', 'Etc']

export const plantationCropName=['Sugarcane', 'Coffee', 'Tea']